import React from 'react';
import SpecialOffersBelowTheFold from '@hpstellar/pdp/SpecialOffersBelowTheFold';

import withPageComponents from '../../../page/components/with-page-components';

import './pdp-offers.less';

const pdpGallery = ({ pdpSpecialOffers }) => {
    if (pdpSpecialOffers) {
        const { title, offers } = pdpSpecialOffers;
        return <SpecialOffersBelowTheFold className="pdpOffers" title={title} offers={offers} />;
    }
    return null;
};

export default withPageComponents(pdpGallery, { components: ['pdpSpecialOffers'] });
